import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Utils } from "@/shared/utils/utils";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";

import { DashboardCard } from "../../models/DashboardCard";
import { Http } from "@status/codes";
import { FormsService } from "@/modules/Forms/services/FormService";
import { INFO_CARD_TASK } from "../../constants/DashboardConstants";
import { mapGetters } from "vuex";
import { PANEL_INFO_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import DashboardItemLink from "./../DashboardItemLink/DashboardItemLink.vue";
import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";

@Component({
  name: "DashboardCardElement",
  components: { DashboardItemLink },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class DashboardCardElement extends Vue {
  @Inject() formsService!: FormsService;

  @Prop() card!: DashboardCard;
  @Prop({ default: () => false }) iconBig!: boolean;
  @Prop({ default: () => false }) isOpen!: boolean;

  iscollapse = true;
  valueFloat = 0;

  cardClass = STYLE_CLASSES.CARD;
  btnClassPrimaryRound = STYLE_CLASSES.ROUND_BTN;
  dataToMainView!: MenuDataStructure;

  mounted() {
    this.iscollapse = !this.isOpen;
    this.getValueFloat();
  }

  async getValueFloat() {
    if (!this.card.floatReference) {
      this.valueFloat = 0;
      return;
    }
    if (this.card.floatReference == INFO_CARD_TASK.floatReference) {
      if (this.valueFloat <= 0) {
        this.valueFloat = await this.taskNumber();
      }
      return;
    }
  }

  actionClick() {
    const newRoute = Utils.calculeNewRoute(this.card, false);
    if (newRoute) {
      this.$router.push(newRoute);
    }
  }

  async taskNumber(): Promise<number> {
    try {
      const userId = localStorage.getItem(LOCAL_STORAGE.UID) || "";
      const data = await this.formsService.userForms(userId);

      if (data.code == Http.Found && data.data !== undefined) {
        return Utils.numberTask(data.data);
      }
      return 0;
    } catch (e) {
      return 0;
    }
  }

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.TASK &&
      this.dataToMainView.action === PANEL_INFO_CONSTANTS.ACTION.SHOW
    ) {
      this.valueFloat = this.dataToMainView.data.taskNumber;
    }
  }
}
